import { Box, Heading, SkeletonRectangle } from '@wix/design-system';
import { useIsStudioNewUi } from '@wix/package-picker-shared-studio';
import React from 'react';
import { useTitleKey } from '../../hooks';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './PageTitle.scss';

export const PageTitle = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { key, params, isLoading } = useTitleKey();
  const isStudioNewUi = useIsStudioNewUi();

  if (isStudioNewUi && isLoading) {
    return (
      <Box width="100%" align="center">
        <SkeletonRectangle
          dataHook="page-title-loading"
          width="600px"
          height="45px"
        />
      </Box>
    );
  }

  return (
    <Box width="100%" align="center">
      <Heading
        size="extraLarge"
        className={isStudioNewUi ? s.newUiPageTitle : s.pageTitle}
      >
        {t(key, params)}
      </Heading>
    </Box>
  );
};
